import { styled } from 'styled-components'
import { TILE_BEFORE_AFTER_SOURCE_PHOTO_SIZE_PX } from '../../cartUpsells.consts'
import { ReactComponent as ArrowSvg } from './TileBeforeAfterArrow.svg'

// Laid out as in the bag card's design (Figma 4806:22598).
export const Row = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 145px;
  height: 120px;
`

export const ResultTileBox = styled.div`
  position: absolute;
  top: 16px;
  left: 46px;
  width: 93px;
  height: 93px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    -0.7px -0.7px 7px 0 rgba(0, 0, 0, 0.07),
    8.1px 8.1px 6.3px 0 rgba(0, 0, 0, 0.11),
    4.5px 4.5px 3.5px 0 rgba(0, 0, 0, 0.09),
    2.4px 2.4px 1.9px 0 rgba(0, 0, 0, 0.07),
    1px 1px 0.8px 0 rgba(0, 0, 0, 0.05);
`

export const SourcePhotoClip = styled.div`
  position: absolute;
  top: 11px;
  left: 20px;
  z-index: 1;
  box-sizing: content-box;
  width: ${TILE_BEFORE_AFTER_SOURCE_PHOTO_SIZE_PX.width}px;
  height: ${TILE_BEFORE_AFTER_SOURCE_PHOTO_SIZE_PX.height}px;
  overflow: hidden;
  border: 1.8px solid ${({ theme }) => theme.colors.white};
  border-radius: 5.4px;
  background-color: ${({ theme }) => theme.colors.grayBright};
  box-shadow: 0 3.6px 3.6px rgba(0, 0, 0, 0.15);

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: inset 1.8px 2.7px 18px rgba(0, 0, 0, 0.16);
    pointer-events: none;
  }
`

export const SourcePhoto = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  object-fit: cover;
`

export const ArrowBox = styled.div`
  position: absolute;
  top: 77px;
  left: 14px;
  z-index: 1;
  width: 32px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`

export const Arrow = styled(ArrowSvg)`
  flex: none;
  width: 14px;
  height: 30px;
  transform: rotate(-55.12deg) scaleX(-1);
`
